const state = {
  it: {
    firstname: 'nome',
    lastname: 'cognome',
    gender: 'sesso',
    dateofbirth: 'data di nascita',
    countryofbirth: 'stato di nascita',
    cityofbirth: 'comune di nascita',
    countryofresidence: 'stato di residenza',
    cityofresidence: 'comune di residenza',
    citizenship: 'cittadinanza',
    cityofissue: 'città di rilascio',
    countryofissue: 'stato di rilascio',
    addressofresidence: 'indirizzo di residenza',
    documenttype:'tipo di documento',
    documentnumber: 'numero documento',
    dateofissue:'data di rilascio',
    dateofexpiration:'data di scadenza',
    dayofissue:'giorno di rilascio',
    monthofissue:'mese di rilascio',
    yearofissue:'anno di rilascio',
    dayofexpiration:'giorno di scadenza',
    monthofexpiration:'mese di scadenza',
    yearofexpiration:'anno di scadenza',
    issueby:'ente di rilascio',
    email: 'email',
    add_guest: 'aggiungi ospite',
    save_and_send: 'salva e invia',
    room: 'Camera',
    personal_data: 'Dati Personali',
    guida_1: 'Invio dei dati effettuato con successo. Ti aspettiamo in Hotel!',
    guida_2: 'Hai inserito tutti i dati. Clicca su ',
    guida_3: 'per terminare il pre-checkin.',
    guida_4: 'Compila i dati di tutti gli ospiti della prenotazione che troverai suddivisi per camera.',
    guida_5: "Per procedere alla compilazione dell'anagrafica di un'ospite clicca sull'icona ",
    guida_6: " che indica un ospite con un'anagrafica non compilata.",
    guida_7: "Una volta completato l'inserimento dei dati clicca sul bottone",
    guida_8: "Gli ospiti con un'anagrafica inserita cambieranno il loro colore in questo modo",
    guida_9: " ma puoi sempre modificare qualche dato in caso di errori cliccando su di essi.",
    guida_10:" A differenza degli altri ospiti, il capo della prenotazione è caratterizzato da un badge a forma di stella ",
    guida_11:"Una volta completato l'inserimento dei dati di tutti gli ospiti clicca sul bottone",
    guida_12:"e la procedura sarà terminata. A presto!",
    welcome_inizia:"inizia",
    welcome_accetto:"Accetto",
    WelcomeText: '',
    GoodbyeText: '',
    PrivacyText: '',
    ContractText:'',
    instructions: 'istruzioni',
    done:'Fatto!',
    all_data_inserted:'Hai inserito tutti i dati. Clicca su Salva e Invia',
    success_message:'Invio dei dati effettuato con successo. Ti aspettiamo in Hotel!',
    select_next_guest:'Seleziona il prossimo ospite',
    confirm_question:'Inviando i dati non potrai più effettuare modifiche. Vuoi procedere con l\'invio?',
    ditta_dati_fatturazione:'Dati per la fatturazione',
    ditta_ragionesociale:'Ragione sociale',
    ditta_country:'Nazione',
    ditta_city:'Citta',
    ditta_indirizzo:'Indirizzo',
    ditta_cap:'CAP',
    ditta_piva:'Partita IVA',
    ditta_codice_fiscale:'Codice Fiscale',
    ditta_codice_destinatario:'Codice Destinatario',
    ditta_pec:'PEC fatturazione',
    codfiscale:'codice fiscale',
    dayofbirth:'giorno',
    monthofbirth:'mese',
    yearofbirth:'anno',
    next: 'avanti',
    nguests: 'Conferma il numero di ospiti',
    invoice_check: 'Desidero indicare dati di fatturazione diversi da quelli personali',
    phone: 'Telefono',
    targa: 'Targa',
    imgfront:'Foto fronte documento',
    imgback:'Foto retro documento',
    riepilogo_prenotazione:'Riepilogo Prenotazione',
    alloggio:'Alloggio',
    ho_preso_visione:'Clicca qui per firmare',
    conferma_e_firma:'Conferma di aver letto il regolamento e procedi all firma',
    contratto:'Contratto',
    firma_qui:'Firma qui',
    SOGG:'Soggiorno',
    EXTRA:'Extra',
    TAX:'Imposte',
    data_arrivo:'Data inizio soggiorno',
    data_partenza:'Data fine soggiorno',
    totale:'Costo totale del soggiorno',
    struttura:'Struttura'
  },
  en: {
    firstname: 'first name',
    lastname: 'last name',
    gender: 'gender',
    dateofbirth: 'date of birth',
    countryofbirth: 'country of birth',
    cityofbirth: 'city of birth',
    countryofresidence: 'country of residence',
    cityofresidence: 'city of residence',
    citizenship: 'citizenship',
    cityofissue: 'city of issue',
    countryofissue: 'country of issue',
    addressofresidence: 'address of residence',
    documenttype: 'document type',
    documentnumber: 'documentnumber',
    dateofissue:'date of issue',
    dateofexpiration:'date of expiration',
    dayofissue:'day of issue',
    monthofissue:'month of issue',
    yearofissue:'year of issue',
    dayofexpiration:'expiration day',
    monthofexpiration:'expiration month',
    yearofexpiration:'exipration year',
    issueby:'issuing institution',
    email: 'email',
    add_guest: 'add guest',
    save_and_send: 'save and send',
    room:'Room',
    personal_data:'Personal Data',
    guida_1: 'Data sent successfully. We are waiting for you in the Hotel!',
    guida_2: 'You have entered all the data. Click on ',
    guida_3: 'to finish the pre-checkin.',
    guida_4: 'Fill in the details of all the guests of the reservation that you will find by room.',
    guida_5: "To proceed with the compilation of a guest's record, click on the icon",
    guida_6: 'that indicates a guest with an incomplete registry.',
    guida_7: "Once the data entry is complete click on the button",
    guida_8: "Guests with an inserted registry will change their color in this way",
    guida_9: "but you can always change some data in case of errors by clicking on them.",
    guida_10: "Unlike other guests, the main guest of the reservation is characterized by a star-shaped badge",
    guida_11: "Once you have completed the entry of all guests, click on the button",
    guida_12: "and the procedure will be terminated. See you soon!",
    welcome_inizia: "begin",
    welcome_accetto:"I Accept",
    WelcomeText:"",
    GoodbyeText:"",
    PrivacyText:"",
    ContractText:'',
    instructions: 'instructions',
    all_data_inserted:'You have entered all the data. Click on Save and Send',
    success_message:'Sending data successfully. We are waiting for you at the Hotel!',
    select_next_guest:'Select the next guest',
    confirm_question:'By sending the data you will no longer be able to make changes. Do you want to proceed with the sending?',
    ditta_dati_fatturazione:'Billing informations',
    ditta_ragionesociale:'Company Name',
    ditta_country:'Country',
    ditta_city:'City',
    ditta_indirizzo:'Address',
    ditta_cap:'Postal Code',
    ditta_piva:'VAT number',
    ditta_codice_fiscale:'Codice Fiscale',
    ditta_codice_destinatario:'Codice Destinatario',
    ditta_pec:'PEC fatturazione',
    codfiscale:'fiscal code',
    dayofbirth:'day',
    monthofbirth:'month',
    yearofbirth:'year',
    next: 'next',
    nguests: 'Confirm the number of guests',
    invoice_check: 'I want to put invoice in name of a company',
    phone: 'Telephone Number',
    targa: 'car license plate',
    imgfront:'Photo front of identity document',
    imgback:'Photo back of identity document',
    regolamento:'Regulation',
    riepilogo_prenotazione:'Reservation summary',
    alloggio:'Room',
    ho_preso_visione:'I have read the contract',
    conferma_e_firma:'Please, confirm you`ve read the Rules and regulation e sign here',
    contratto:'Contract',
    firma_qui:'Sign here. Use the whole box',
    SOGG:'Lodging',
    EXTRA:'Extra en',
    TAX:'TAX EN',
    data_arrivo:'Check-in',
    data_partenza:'Check-out',
    totale:'Total cost of stay',
    struttura:'Struttura'
  },
  es: {
    firstname: 'nombre',
    lastname: 'apellido',
    gender: 'sexo',
    dateofbirth: 'fecha de nacimiento',
    countryofbirth: 'estado de nacimiento',
    cityofbirth: 'ciudad de nacimiento',
    countryofresidence: 'estado de residencia',
    cityofresidence: 'municipio de residencia',
    citizenship: 'ciudadanía',
    cityofissue: 'ciudad emisora',
    countryofissue: 'estado emisorio',
    addressofresidence: 'domicilio residencial',
    documenttype:'tipo de documento',
    documentnumber: 'número de documento',
    dateofissue:'fecha de emisión',
    dateofexpiration:'fecha de expiración',
    dayofissue:'día de emisión',
    monthofissue:'mes de emisión',
    yearofissue:'año de emisión',
    dayofexpiration:'día de expiración',
    monthofexpiration:'mes de expiración',
    yearofexpiration:'año de expiración',
    issueby:'institución emisora',
    email: 'email',
    add_guest: 'agregar invitado',
    save_and_send: 'guardar y enviar',
    room: 'habitación',
    personal_data: 'información personal',
    guida_1: 'Enviando datos con éxito. Te esperamos en el hotel!',
    guida_2: 'Has introducido todos los datos. Haga clic en ',
    guida_3: 'para finalizar el pre-checkin.',
    guida_4: 'Complete los detalles de todos los huéspedes de la reserva que encontrará divididos por habitación.',
    guida_5: "Para continuar con la compilación de un registro de invitados, haga clic en el icono ",
    guida_6: " que indica un invitado con datos personales no recopilados.",
    guida_7: " Una vez que los datos han sido ingresados, haga clic en el botón",
    guida_8: "Los invitados con un registro insertado cambiarán su color de esta manera",
    guida_9: " pero siempre puede cambiar algunos datos en caso de errores haciendo clic en ellos.",
    guida_10:" A diferencia de los otros huéspedes, el jefe de la reserva tiene una insignia en forma de estrella ",
    guida_11:"Una vez que se hayan ingresado los datos de todos los invitados, haga clic en el botón",
    guida_12:"y el procedimiento será terminado. Hasta pronto!",
    welcome_inizia:"comienzas",
    welcome_accetto:"Acepto",
    WelcomeText:"",
    GoodbyeText:"",
    PrivacyText:"",
    ContractText:'',
    instructions: 'instrucciones',
    all_data_inserted:'Has introducido todos los datos. Haga clic en Guardar y enviar',
    success_message:'Enviando datos con éxito. ¡Te esperamos en el Hotel!',
    select_next_guest:'Seleccione el próximo invitado',
    confirm_question:'Al enviar los datos, ya no podrá realizar cambios. ¿Quieres continuar con el envío?',
    ditta_dati_fatturazione:'Información de facturación',
    ditta_ragionesociale:'Nombre de la empresa',
    ditta_country:'Pais',
    ditta_city:'Ciudad',
    ditta_indirizzo:'Direccion',
    ditta_cap:'PAC',
    ditta_piva:'Numero de IVA',
    ditta_codice_fiscale:'Codice Fiscale',
    ditta_codice_destinatario:'Codice Destinatario',
    ditta_pec:'PEC fatturazione',
    codfiscale:'código fiscal',
    dayofbirth:'día',
    monthofbirth:'mes',
    yearofbirth:'año',
    next: 'siguiente',
    nguests: 'Confirmar el número de invitados',
    invoice_check: 'Necesito factura',
    phone: 'número de teléfono',
    targa: 'matrícula del coche',
    imgfront:'Foto frontal del documento de identidad',
    imgback:'Foto del reverso del documento de identidad',
    riepilogo_prenotazione:'Resumen de la reserva',
    alloggio:'habitación',
    ho_preso_visione:'he leido el contrato',
    conferma_e_firma:'Confirma que has leído el reglamento y procede con la firma',
    regolamento:'Regulación',
    contratto:'Contrato',
    firma_qui:'Firma aqui',
    SOGG:'Lodging',
    data_arrivo:'Check-in',
    data_partenza:'Check-out',
    totale:'Coste total de la estancia',
    struttura:'Struttura'
  }, 
  de: {
    firstname: 'Name',
    lastname: 'Nachname',
    gender: 'Sex',
    dateofbirth: 'Geburtsdatum',
    countryofbirth: 'Geburtszustand',
    cityofbirth: 'gemeinsame Geburt',
    countryofresidence: 'Wohnsitzstaat',
    cityofresidence: 'Wohnsitzgemeinde',
    citizenship: 'Staatsbürgerschaft',
    cityofissue: 'Stadt freigeben',
    countryofissue: 'Freigabestatus',
    addressofresidence: 'Wohnadresse',
    documenttype:'Art des Dokuments',
    documentnumber: 'Dokumentennummer',
    dateofissue:'Datum der Ausstellung',
    dateofexpiration:'Datum des Ablaufs',
    dayofissue:'Tag der Ausgabe',
    monthofissue:'Monat der Ausgabe',
    yearofissue:'Jahr der Ausgabe',
    dayofexpiration:'Verfallstag',
    monthofexpiration:'Verfallsmonat',
    yearofexpiration:'Verfallsjahr',
    issueby:'ausstellendes Institut',
    email: 'email',
    add_guest: 'Gast hinzufügen',
    save_and_send: 'Speichern und senden',
    room: 'Zimmer',
    personal_data: 'Persönliche Daten',
    guida_1: 'Daten erfolgreich senden. Wir erwarten Sie im Hotel!',
    guida_2: 'Sie haben alle Daten eingegeben. Klicken Sie auf ',
    guida_3: 'um den Pre-Check-in zu beenden.',
    guida_4: 'Füllen Sie die Details aller Gäste der Reservierung aus, die Sie durch Raum geteilt finden.',
    guida_5: "Um mit der Erstellung einer Gästeregistrierung fortzufahren, klicken Sie auf das Symbol ",
    guida_6: " was auf einen Gast mit nicht zusammengestellten persönlichen Daten hinweist.",
    guida_7: "Sobald die Daten eingegeben wurden, klicken Sie auf die Schaltfläche",
    guida_8: "Gäste mit einer eingefügten Registrierung ändern auf diese Weise ihre Farbe",
    guida_9: " Sie können jedoch im Fehlerfall jederzeit Daten ändern, indem Sie darauf klicken.",
    guida_10:" Im Gegensatz zu den anderen Gästen trägt der Reservierungsleiter ein sternförmiges Abzeichen ",
    guida_11:"Nachdem Sie die Daten für alle Gäste eingegeben haben, klicken Sie auf die Schaltfläche",
    guida_12:"und der Vorgang wird abgebrochen. Bis bald",
    welcome_inizia:"beginnt",
    welcome_accetto:"Ich akzeptiere",
    WelcomeText: '',
    GoodbyeText: '',
    PrivacyText: '',
    ContractText:'',
    instructions: 'Anleitung',
    all_data_inserted:'Sie haben alle Daten eingegeben. Klicken Sie auf Speichern und senden',
    success_message:'Daten erfolgreich senden. Wir erwarten Sie im Hotel!',
    select_next_guest:'Wählen Sie den nächsten Gast aus',
    confirm_question:'Durch das Senden der Daten können Sie keine Änderungen mehr vornehmen. Möchten Sie mit dem Senden fortfahren?',
    ditta_dati_fatturazione:'Rechnungsinformationen',
    ditta_ragionesociale:'Firmenname',
    ditta_country:'Land',
    ditta_city:'Stadt',
    ditta_indirizzo:'Adresse',
    ditta_cap:'CAP',
    ditta_piva:'Identifikationsnummer',
    ditta_codice_fiscale:'Codice Fiscale',
    ditta_codice_destinatario:'Codice Destinatario',
    ditta_pec:'PEC fatturazione',
    codfiscale:'Steuerkennzeichen',
    dayofbirth:'Tag',
    monthofbirth:'Monat',
    yearofbirth:'Jahr',
    next: 'Nächste',
    nguests: 'Bestätigen Sie die Anzahl der Gäste',
    invoice_check: 'Ich brauche eine Rechnung',
    phone: 'Telefonnummer',
    targa: 'Autokennzeichen',
    imgfront:'Frontfoto des Ausweises',
    imgback:'Rückseitenfoto des Ausweises',
    riepilogo_prenotazione:'Zusammenfassung der Reservierung',
    alloggio:'zimmer',
    ho_preso_visione:'Ich habe den Vertrag gelesen',
    conferma_e_firma:'Bestätigen Sie, dass Sie die Regeln gelesen haben, und fahren Sie mit der Unterzeichnung fort',
    regolamento:'Verordnung',
    contratto:'Vertrag',
    firma_qui:'Hier unterschreiben',
    data_arrivo:'Check-in',
    data_partenza:'Check-out',
    totale:'Gesamtkosten des Aufenthalts',
    struttura:'Struttura'
  },
  fr: {
    firstname: 'Prenom',
    lastname: 'nom de famille',
    gender: 'sexe',
    dateofbirth: 'date de naissance',
    countryofbirth: 'état de naissance',
    cityofbirth: 'naissance commune',
    countryofresidence: 'état de résidence',
    cityofresidence: 'commune de résidence',
    citizenship: 'citoyenneté',
    cityofissue: 'ville de libération',
    countryofissue: 'statut de libération',
    addressofresidence: 'adresse résidentielle',
    documenttype:'type de document',
    documentnumber: 'numéro de document',
    dateofissue : "date de délivrance",
    dateofexpiration : "date d'expiration",
    dayofissue:'jour du numéro',
    monthofissue:'mois du numéro',
    yearofissue:'année de délivrance',
    dayofexpiration:`jour d'expiration`,
    monthofexpiration:`mois d'expiration`,
    yearofexpiration:`année d'expiration`,
    issueby:'organisme émetteur',
    email: 'email',
    add_guest: 'ajouter un invité',
    save_and_send: 'enregistrer et envoyer',
    room: 'chambre',
    personal_data: 'Données personnelles',
    guida_1: "Envoi de données avec succès. Nous vous attendons à l'hôtel!",
    guida_2: 'Vous avez entré toutes les données. Cliquez sur ',
    guida_3: 'pour terminer le pré-check in',
    guida_4: 'Remplissez les détails de tous les invités de la réservation, vous trouverez divisé par chambre.',
    guida_5: "Pour procéder à la compilation d'un registre d'invités, cliquez sur l'icône. ",
    guida_6: " qui indique un invité avec des données personnelles non compilées.",
    guida_7: "Une fois les données saisies, cliquez sur le bouton",
    guida_8: "Les invités avec un registre inséré changeront de couleur de cette façon",
    guida_9: " mais vous pouvez toujours modifier certaines données en cas d'erreur en cliquant dessus.",
    guida_10:" Contrairement aux autres invités, le responsable de la réservation porte un badge en forme d'étoile ",
    guida_11:"Une fois que les données pour tous les invités ont été entrées, cliquez sur le bouton.",
    guida_12:"et la procédure sera terminée. À bientôt!",
    welcome_inizia:"commence",
    welcome_accetto:"J'accepte",
    WelcomeText: '',
    GoodbyeText: '',
    PrivacyText: '',
    ContractText:'',
    instructions: 'instructions',
    all_data_inserted:'Vous avez entré toutes les données. Cliquez sur Enregistrer et envoyer',
    success_message:'Envoi de données avec succès. Nous vous attendons à l\'hôtel!',
    select_next_guest: 'Sélectionnez l\'invité suivant',
    confirm_question:'En envoyant les données, vous ne pourrez plus apporter de modifications. Voulez-vous procéder à l\'envoi?',
    ditta_dati_fatturazione:'Informations de facturation',
    ditta_ragionesociale:'Nom de la société',
    ditta_country:'Pays',
    ditta_city:'Ville',
    ditta_indirizzo:'Adresse',
    ditta_cap:'CAP',
    ditta_piva:'Numéro de TVA',
    ditta_codice_fiscale:'Codice Fiscale',
    ditta_codice_destinatario:'Codice Destinatario',
    ditta_pec:'PEC fatturazione',
    codfiscale:'code fiscal',
    dayofbirth:'jour',
    monthofbirth:'mois',
    yearofbirth:'année',
    next: 'suivant',
    nguests: 'Confirmer le nombre d´invités',
    invoice_check: 'J´ai besoin d´une facture',
    phone: 'numéro de téléphone',
    targa: 'plaque d\'immatriculation de voiture',
    imgfront:'Photo recto de la carte d`identité',
    imgback:'Photo du verso de la carte d`identité',
    riepilogo_prenotazione:'Résumé de la réservation',
    alloggio:'chambre',
    ho_preso_visione:'j`ai lu le contrat',
    conferma_e_firma:'Confirmez que vous avez lu le règlement et procédez à la signature',
    regolamento:'Contrat',
    firma_qui:'signez ici',
    data_arrivo:'Check-in',
    data_partenza:'Check-out',
    totale:'Coût total du séjour',
    struttura:'Struttura'
  },
}

export default {
  state
}
